import React, { useEffect, useState } from "react";

const MONTHS = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

export default function MonthSelect({ value = "", onChange, testId, className = "", allowClear = false, allowYearOnly = false }) {
  const nowYear = new Date().getFullYear();
  const monthValue = /^\d{4}-\d{2}$/.test(value);
  const yearValue = allowYearOnly && /^\d{4}$/.test(value);
  const [valueYear, selectedMonth] = monthValue ? value.split("-") : [yearValue ? value : "", ""];
  const [draftYear, setDraftYear] = useState(valueYear || String(nowYear));
  const selectedYear = valueYear || draftYear;
  useEffect(() => {
    if (valueYear) setDraftYear(valueYear);
  }, [valueYear]);
  const years = Array.from({ length: 21 }, (_, index) => String(nowYear - 10 + index));
  if (selectedYear && !years.includes(selectedYear)) years.push(selectedYear);
  years.sort();

  const updateMonth = (month) => onChange(month ? `${selectedYear || nowYear}-${month}` : "");
  const updateYear = (year) => {
    setDraftYear(year);
    if (selectedMonth) onChange(`${year}-${selectedMonth}`);
    else if (allowYearOnly) onChange(year);
  };

  return (
    <div className={`inline-flex items-center gap-1 ${className}`} data-testid={testId}>
      <select aria-label="Month" data-testid={testId ? `${testId}-month` : undefined} value={selectedMonth} onChange={(event) => updateMonth(event.target.value)}
        className="bg-[#FDFBF7] border border-[#EAE6DF] rounded-lg px-3 py-2 text-sm text-[#2D312E]">
        <option value="">{allowYearOnly ? "All months" : "Month"}</option>
        {MONTHS.map((name, index) => <option key={name} value={String(index + 1).padStart(2, "0")}>{name}</option>)}
      </select>
      <select aria-label="Year" data-testid={testId ? `${testId}-year` : undefined} value={selectedYear} onChange={(event) => updateYear(event.target.value)}
        className="bg-[#FDFBF7] border border-[#EAE6DF] rounded-lg px-3 py-2 text-sm text-[#2D312E]">
        {years.map((year) => <option key={year} value={year}>{year}</option>)}
      </select>
      {allowClear && value && <button type="button" onClick={() => onChange("")} className="px-2 py-2 text-xs text-[#8A938D] hover:text-[#C05746]" aria-label="Clear month">Clear</button>}
    </div>
  );
}
